import { Inline, Skeleton, Stack } from '@omnipresentgroup/design-system';

export const RadioFieldSkeleton = ({
  // eslint-disable-next-line no-magic-numbers
  numberOfOptions = 1,
}: {
  numberOfOptions?: number;
}) => {
  return (
    <Stack gap="4">
      <Inline h={24} align="center">
        <Skeleton height={14} width={150} />
      </Inline>
      {Array.from({ length: numberOfOptions }, (_, index) => (
        <Inline key={index} h={24} gap="4" align="center">
          <Skeleton height={16} width={16} circle />
          <Skeleton height={16} width={100} />
        </Inline>
      ))}
    </Stack>
  );
};
